import React from 'react';

const UploadStatus = ({ data }) => {
    return (
        <div className='row mt-2'>
            <div className='table-responsive new-table-mnp'>
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Ref No</th>
                            <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((x, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{x.refno}</td>
                                <td>{x.msg}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UploadStatus;
